import Swal from 'sweetalert2';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { LOGOUT } from "@/utils/logout.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";

export default {
  name: 'OnBehalfOnboarding',
  components: {
    ClientLogo
  },
  mixins: [LOGOUT, MAIN_CONTROLLER],
  data() {
    return {
      fullName: '',
      description: '',
      errors: {
        fullName: ''
      },
      isSubmitting: false
    };
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    
    // Check if we have the necessary workflow information
    if (!localStorage.getItem('onboarding_workflow_id')) {
      this.$router.push({ name: 'Dashboard' });
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    
    validateForm() {
      let isValid = true;
      this.errors = {
        fullName: ''
      };
      
      if (!this.fullName.trim()) {
        this.errors.fullName = 'Full name is required';
        isValid = false;
      }
      
      return isValid;
    },
    
    submit_form() {
      if (!this.validateForm()) {
        return;
      }
      
      this.isSubmitting = true;
      const token = localStorage.getItem('token');
      const base_url = API_BASE_URL;
      
      const workflow_id = localStorage.getItem('onboarding_workflow_id');
      const parent_workflow_id = localStorage.getItem('onboarding_parent_id');
      const parent_service_workflow_id = localStorage.getItem('onboarding_service_workflow_id');
      
      // Save the parent workflow ID for later use
      localStorage.setItem('parent_workflow_id', parent_workflow_id);
      
      const url = `${base_url}/verify_api/service_management_api/create_on_behalf_application/`;
      
      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${token}`
        },
        data: JSON.stringify({
          workflow_id: workflow_id,
          parent_service_workflow_id: parent_service_workflow_id,
          parent_workflow_id: parent_workflow_id,
          full_name: this.fullName,
          description: this.description
        }),
        beforeSend: () => {
          Swal.fire({
            text: 'Processing your request...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          this.isSubmitting = false;
          Swal.close();
          
          if (response.status === 'success') {
            // Store the sub-workflow ID as the current workflow
            this.$store.dispatch('update_workflow_id', workflow_id);
            this.fetch_current_service();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.message || 'Failed to create application',
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false
            });
          }
        },
        error: (xhr) => {
          this.isSubmitting = false;
          Swal.close();
          
          const error_msg = xhr.responseJSON?.message || 'Failed to create application';
          Swal.fire({
            icon: 'error',
            title: 'System Error',
            text: error_msg,
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
        }
      });
    }
  }
};
